<template>
  <div id="document">
    <b-container fluid>
      <b-row>
        <b-col cols="auto" class="text-left mr-auto">
          <b-row>
            <b-col cols="auto">
              <v-select
                v-model="corporationSelected"
                :options="platforms"
                :searchable="true"
                :clearable="false"
                label="name"
                style="min-width: 300px;"
                @change="filters(documentFilter)"
              />
            </b-col>
            <b-col cols="auto">
              <b-button class="btn-block add-btn" @click="addDocument">
                สร้างเอกสาร
              </b-button>
            </b-col>
            <template
              v-if="documentTypes.map((document) => document.id).includes(5)"
            >
              <b-col cols="auto">
                <!--              <b-button class="btn-block add-btn" @click="addBlankDocument">สร้างฟอร์มเปล่า</b-button>-->
                <blank-document-form-modal />
              </b-col>
            </template>
          </b-row>
        </b-col>
        <b-col cols="auto" class="text-right">
          <!--          <b-button class="btn-block cover-print-btn" @click="printCoverPage">-->
          <!--            <fa-icon icon="print"/>-->
          <!--            พิมพ์ใบปะหน้า-->
          <!--          </b-button>-->
          <cover-page-modal :document-filter="documentFilter" />
        </b-col>
      </b-row>

      <b-row class="pt-2">
        <b-container fluid>
          <full-search-filter
            :document-selected="documentSelected"
            :first-filter="documentFilter"
            :filters="filters"
            :hospitals="hospitalOption"
          />
          <document-nav
            :document-types="documentTypes"
            :document-selected.sync="documentSelected"
            :filters="filters"
          />
          <account-table
            :filters="filters"
            :document-selected="documentSelected"
          />
        </b-container>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DocumentNav from "../../components/Account/DocumentNav";
import FullSearchFilter from "../../components/FullSearchFilter";
import AccountTable from "../../components/Account/AccountTable";
import CoverPageModal from "../../components/Account/CoverPageModal";
import BlankDocumentFormModal from "../../components/Account/BlankDocumentFormModal";
import moment from "moment-timezone";

export default {
  name: "DocumentComponent",
  components: {
    DocumentNav,
    FullSearchFilter,
    AccountTable,
    CoverPageModal,
    BlankDocumentFormModal,
  },
  data() {
    return {
      // corporationSelected: null,
      documentSelected: null,
      documentIdSelected: null,
      hospitalOption: [],
    };
  },
  computed: {
    ...mapGetters({
      platforms: "Account/getPlatforms",
      documentTypes: "Account/getDocumentType",
      filterDocumentTypes: "Account/getFilterDocumentType",
      getDocumentSelected: "Account/getDocumentSelected",
      documentsFilter: "Account/getFilterDocument",
      hospitals: "Hospital/getAll",
      paymentStatus: "Account/getPaymentStatuses",
      corporationObjectSelected: "Account/getCorporationObjectSelected",
    }),
    documentTypes() {
      return this.corporationSelected
        ? this.corporationSelected.documentTypes
        : [];
    },
    corporationSelected: {
      get() {
        return this.$store.state.Account.corporationId;
      },
      set(val) {
        this.$store.commit("Account/SET_CORPORATION_ID", val);
      },
    },
    documentFilter: {
      get() {
        return this.$store.state.Account.documentFilter;
      },
      set(val) {
        this.$store.commit("Account/SET_DOCUMENT_FILTER", val);
      },
    },
  },
  watch: {
    async corporationSelected() {
      this.includingDocument();
      await this.filters(this.documentFilter);
      this.documentSelected = this.filterDocumentTypes[0].id;
    },
    documentSelected(newVal) {
      this.documentFilter.document_type_id = newVal;
      this.documentFilter.page_no = "1";
    },
  },
  async mounted() {
    // await this.setDocuments();
    await this.setPlatforms();
    await this.setDocumentType();
    // await this.paymentStatus()

    if (!this.corporationSelected) {
      this.corporationSelected = this.platforms[0];
    }
    await this.includingDocument();
    await this.setPaymentStatuses();
    this.documentSelected = this.filterDocumentTypes[0].id;
    await this.hospitalFilterOptions();
  },
  methods: {
    ...mapActions({
      setPlatforms: "Account/setPlatforms",
      setDocumentType: "Account/setDocumentType",
      setFilterDocumentType: "Account/setFilterDocumentType",
      setFilterDocument: "Account/setFilterDocument",
      setDocumentSelected: "Account/setDocumentSelected",
      setPaymentStatuses: "Account/setPaymentStatuses",
      checkPermission: "Order/checkPermission",
    }),
    async hospitalFilterOptions() {
      let hospitals = this.hospitals;

      if (this.corporation) {
        this.hospitalOption = hospitals.filter(
          (hospital) => hospital.corporation_id === this.corporation.id
        );
      }
    },
    addDocument() {
      this.$router.push({
        name: "document",
      });
    },
    async includingDocument() {
      let filterTypes = [];
      this.platforms.forEach((c) => {
        if (
          c.id === this.corporationSelected.id &&
          c.platform_type === this.corporationSelected.platform_type
        ) {
          let documentTypeId = c.document_type_id;
          this.documentTypes.forEach((d) => {
            if (documentTypeId.includes(d.id)) {
              filterTypes.push(d);
            }
          });
        }
      });
      await this.setFilterDocumentType(filterTypes);
    },
    async filters(obj) {
      let val = {};
      if (obj.dateTwo === "") {
        let corporation;
        if (this.corporationSelected) {
          corporation = this.corporationSelected;
        }
        val = {
          page_no: obj.page_no != null ? obj.page_no : "1",
          direction_id: obj.direction != null ? obj.direction.id : "",
          hospital_id: obj.hospital != null ? obj.hospital.id : "",
          in: obj.in != null ? obj.in : "",
          corporationId:
            corporation && corporation.platform_type === "corporation"
              ? corporation.id
              : "",
          otherCorporationId:
            corporation && corporation.platform_type === "other"
              ? corporation.other_corporation_id
              : "",
          start_date: obj.dateOne
            ? moment(obj.dateOne).format("YYYY-MM-DD")
            : "",
          end_date: obj.dateOne ? moment(obj.dateOne).format("YYYY-MM-DD") : "",
          document_type_id: this.documentSelected ? this.documentSelected : 1,
          paymentStatus: obj.paymentStatus ? obj.paymentStatus : null,
          noInvoice: obj.noInvoice ? obj.noInvoice : false,
        };
      } else {
        let corporation;
        if (this.corporationSelected) {
          corporation = this.corporationSelected;
        }
        val = {
          page_no: obj.page_no != null ? obj.page_no : "1",
          direction_id: obj.direction != null ? obj.direction.id : "",
          hospital_id: obj.hospital != null ? obj.hospital.id : "",
          in: obj.in != null ? obj.in : "",
          corporationId:
            corporation && corporation.platform_type === "corporation"
              ? corporation.id
              : "",
          otherCorporationId:
            corporation && corporation.platform_type === "other"
              ? corporation.other_corporation_id
              : "",
          start_date: obj.dateOne
            ? moment(obj.dateOne).format("YYYY-MM-DD")
            : obj.start_date
            ? moment(obj.start_date).format("YYYY-MM-DD")
            : "",
          end_date: obj.dateTwo ? moment(obj.dateTwo).format("YYYY-MM-DD") : "",
          document_type_id: this.documentSelected ? this.documentSelected : 1,
          paymentStatus: obj.paymentStatus ? obj.paymentStatus : null,
          noInvoice: obj.noInvoice ? obj.noInvoice : false,
        };
      }

      this.documentFilter = obj;
      this.$store.state.isLoading = true;
      await this.setFilterDocument(val);
      this.$store.state.isLoading = false;
      this.documentFilter.page_no = "1";
      this.filterHospital(val.direction_id);
      this.hospitalFilterOptions();
    },
    filterHospital(val) {
      let newHospitalOption = [];

      this.hospitals.forEach((element) => {
        if (element.direction_id === val || val === "") {
          newHospitalOption.push(element);
        }
      });
      this.hospitalOption = newHospitalOption;
    },
    addBlankDocument() {
      this.$swal.fire("add blank document");
    },
  },
};
</script>

<style lang="scss" scoped>
.add-btn {
  background-color: #009906;
  border: none;
}
</style>
